module.exports = {
	BattleDrama_Update_Data : "BattleDrama_Update_Data",
	BattleDrama_Boss_Update_Data : "BattleDrama_Boss_Update_Data",
	BattleDrama_Quick_Battle_Data : "BattleDrama_Quick_Battle_Data",
	BattleDrama_Top_Update_Data : "BattleDrama_Top_Update_Data",
	BattleDrama_Drama_Reward_Data : "BattleDrama_Drama_Reward_Data",
	BattleDrama_Update_Max_Id : "BattleDrama_Update_Max_Id",          // 更新剧情副本最大章节数，这个事件只有变化的时候才会推送
	BattleDrama_Drama_Next_Dungeon : "BattleDrama_Drama_Next_Dungeon",
	BattleDrama_Drama_Unlock_View : "BattleDrama_Drama_Unlock_View",
	BattleDrama_Drama_Buff_View : "BattleDrama_Drama_Buff_View",
	UpdatePartnerRedStatus : "UpdatePartnerRedStatus",
	BattleDrama_Update_Dun_Id : "BattleDrama_Update_Dun_Id",
	UpdateHookAccumulateTime : "UpdateHookAccumulateTime",
	UpdatePassVedioDataEvent : "UpdatePassVedioDataEvent",
	UpdateDramaProgressDataEvent : "UpdateDramaProgressDataEvent",
	BattleDrama_Update_Cool_Time: "BattleDrama_Update_Cool_Time",
	BattleDrama_Update_Dun_Id: "BattleDrama_Update_Dun_Id",
	
	BattleDramaConst: {
		Normal: 1,
		Diffcult: 2,
	}
}